import { httpservice, httpserviceWithMultipart } from '../services';
import { constants } from '../constant/constant';
import { SLACK_SETTINGS } from '../constant/actionTypes';

export const saveSlackSettings = (object) => (dispatch) => httpserviceWithMultipart('post', object, constants.ADMIN_URL + constants.API.SLACK_SETTINGS)
  .then((response) => {
    dispatch({
      payload: {
        data: response.data,
        count: 1,
      },
      type: SLACK_SETTINGS.POST.SUCCESS,
    });
    return response.data;
  })
  .catch((error) => ({
    status: 0,
    data: error.response && error.response.data ? error.response.data : error,
  }));

export const getSlackSettings = () => (dispatch) => {
  dispatch({
    payload: [],
    type: SLACK_SETTINGS.GET.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.SLACK_SETTINGS}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: SLACK_SETTINGS.GET.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SLACK_SETTINGS.GET.ERROR,
      });
    });
};
